import { Phone, Mail, Star } from "lucide-react";
import googleLogo from "@/assets/google-logo.png";

const TopBar = () => {
  return (
    <div className="fixed top-0 left-0 right-0 z-[60] text-white" style={{ background: 'linear-gradient(135deg, hsl(220,15%,12%) 0%, hsl(0,0%,3%) 100%)' }}>
      <div className="container-luxury flex items-center justify-between h-9 px-4 sm:px-6 lg:px-8 text-xs sm:text-sm">
        <div className="flex items-center gap-4 sm:gap-6">
          <a href="tel:+420733679995" className="flex items-center gap-1.5 hover:opacity-80 transition-opacity">
            <Phone className="h-3 w-3" />
            <span>733 679 995</span>
          </a>
          <a href="mailto:frantisek.babcicky@re-max.cz" className="hidden sm:flex items-center gap-1.5 hover:opacity-80 transition-opacity">
            <Mail className="h-3 w-3" />
            <span>frantisek.babcicky@re-max.cz</span>
          </a>
        </div>
        <a
          href="https://share.google/UFLtljC1tLi6aPoNt"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 hover:opacity-80 transition-opacity"
        >
          <img src={googleLogo} alt="Google" className="h-4 w-4" />
          <div className="flex items-center gap-0.5">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-3 w-3 fill-[#FBBC04] text-[#FBBC04]" />
            ))}
          </div>
          <span>4,9 na základě 80 recenzí</span>
        </a>
      </div>
    </div>
  );
};

export default TopBar;
